import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { receiveLogout } from '../redux/actions/login-form-actions';
import { receiveUser } from '../redux/actions/user-actions';
import { getUser } from '../services/user-service';

export default function useUser() {
  const dispatch = useDispatch();

  const user = useSelector((/** @type {Object} */ state) => state.user);

  const dispatchUser = useCallback(
    (u) => {
      dispatch(receiveUser(u));
    },
    [dispatch]
  );

  const dispatchLogout = useCallback(() => {
    dispatch(receiveLogout);
  }, [dispatch]);

  useEffect(() => {
    (async () => {
      getUser()
        .then((u) => {
          dispatchUser(u);
        })
        .catch(() => {
          dispatchLogout();
        });
    })();
  }, []);

  return user;
}
